import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import styles from "./FileDropzone.module.css";
import Icon from "../Icon/Icon";

type FileDropzoneProps = {
  file: File | null;
  onChange: (file: File | null) => void;

  disabled?: boolean;
};

const FileDropzone: React.FC<FileDropzoneProps> = ({
  file,
  onChange,

  disabled = false,
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        onChange(acceptedFiles[0]);
      }
    },
    [onChange]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: { "application/pdf": [".pdf"] },
    disabled,
  });

  const dropzoneClass = [
    styles.dropzone,
    isDragActive ? styles.active : "",
    disabled ? styles.disabled : "",
  ].join(" ");

  return (
    <div className={styles.wrapper}>
      <div {...getRootProps({ className: dropzoneClass })}>
        <input {...getInputProps()} />
        {file && !isDragActive && (
          <div className={styles.selectedFileContainer}>
            <strong>Archivo seleccionado:</strong> {file.name} (
            {(file.size / 1024).toFixed(1)} KB)
          </div>
        )}
        {isDragActive && (
          <>
            <Icon name="dropzone" size={32} />
            <p>Libere el archivo aquí...</p>{" "}
          </>
        )}
        {!isDragActive && !file && (
          <>
            <Icon name="dropzone" size={32} />
            <p>Arrastra o selecciona un archivo </p>
          </>
        )}
      </div>
    </div>
  );
};

export default FileDropzone;
